export enum exportType {
    /* 需求埋点分析列表 */
    plat = 1,
    /* 用户统计分页 */
    user = 2,
    /* 操作次数统计分页 */
    operation = 3
}

export enum DATE_TYPE {
    // 今日
    DAY = 1,
    // 近一周
    WEEK = 2,
    // 近一月
    MONTH = 3,
    // 近一季度
    QUARTER = 4,
    // 近半年
    YEAR = 5
}

// 统计时间选择的 options
export const DATE_TYPE_OPTIONS = [
    { label: "今日", value: DATE_TYPE.DAY },
    { label: "近一周", value: DATE_TYPE.WEEK },
    { label: "近一月", value: DATE_TYPE.MONTH },
    { label: "近一季度", value: DATE_TYPE.QUARTER },
    { label: "近半年", value: DATE_TYPE.YEAR }
];

export const calcRangeByScope = (scope: number): [Date, Date] => {
    const end = new Date();
    const start = new Date();

    // 统一边界
    end.setHours(23, 59, 59, 999);
    start.setHours(0, 0, 0, 0);

    switch (scope) {
        case DATE_TYPE.DAY: // 今日
            break;
        case DATE_TYPE.WEEK: // 近一周
            start.setDate(start.getDate() - 6);
            break;
        case DATE_TYPE.MONTH: // 近一月
            start.setMonth(start.getMonth() - 1);
            start.setDate(start.getDate() + 1);
            break;
        case DATE_TYPE.QUARTER: // 近一季度
            start.setMonth(start.getMonth() - 3);
            start.setDate(start.getDate() + 1);
            break;
        case DATE_TYPE.YEAR: // 近半年
            start.setMonth(start.getMonth() - 6);
            start.setDate(start.getDate() + 1);
            break;
    }

    return [start, end];
};
